import { PlotSection } from '@/warranty-v3/components/plot-section';
import { Card, CardContent } from '@/warranty-v3/components/ui/card';
import type { WarrantyPenalty } from '@/warranty-v3/entities/warranty-penalty';

import { WarrantyPenaltiesChart } from './warranty-penalties-chart';
import { WarrantyPenaltiesIntroBox } from './warranty-penalties-intro-box';
import { WarrantyPenaltiesTable } from './warranty-penalties-table';

export type WarrantyPenaltiesProps = {
  warrantyPenalties: WarrantyPenalty[];
};

export function WarrantyPenalties({
  warrantyPenalties,
}: WarrantyPenaltiesProps) {
  return (
    <PlotSection sectionName="Penalty Overview">
      <Card className="w-full overflow-x-auto">
        <CardContent>
          <WarrantyPenaltiesIntroBox />

          <div className="flex flex-row gap-x-10">
            <div className="h-96 w-2/5 shrink-0">
              <WarrantyPenaltiesChart warrantyPenalties={warrantyPenalties} />
            </div>

            <div className="h-96 w-full grow">
              <WarrantyPenaltiesTable warrantyPenalties={warrantyPenalties} />
            </div>
          </div>
        </CardContent>
      </Card>
    </PlotSection>
  );
}
